<template>
    <div class="container">
        <div id="codeDom" class="content">
            <img
                style="width: 100%; height: 100%"
                src="static/img/pedigree/luru_haibao.png"
            />
            <div v-if="detail.title" class="title">{{ detail.title }}</div>
            <div v-else class="title">{{ detail.branch }}</div>
            <div v-if="detail.title" class="branch">
                片区·{{ detail.branch }}
            </div>
            <div class="code-content">
                <img v-if="code" class="code-qrcode" :src="code" />
            </div>
        </div>

        <div class="handle">
            <div class="handle-item" @click="download">
                <iain-image-domain
                    w="40"
                    h="40"
                    src="static/img/mine/icon15.png"
                />
                <div class="handle-label">保存</div>
            </div>

            <div class="handle-item" @click="share">
                <iain-image-domain
                    w="40"
                    h="40"
                    src="static/img/mine/icon16.png"
                />
                <div class="handle-label">分享</div>
            </div>
        </div>
    </div>
</template>

<script>
import QRCode from "qrcode";
import html2canvas from "html2canvas";

export default {
    name: "UserCode",
    data() {
        return {
            detail: {},

            code: "",
            cover: false,

            codePoster: "",

            Loading: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.Loading = this.$toast.loading({ message: "生成二维码中..." });
            const detail = JSON.parse(this.$route.query.query);
            this.detail = detail;
            await this.setCode();

            this.Loading.message = "生成海报中...";
            this.$nextTick(this.generatePoster);
        },

        async setCode() {
            const code = await QRCode.toDataURL(
                "https://client.kinfriend.com/qrcode/a/pedigree.html?teamId=" +
                    this.detail.codeText,
                { width: 400, height: 400, margin: 0 }
            );

            if (!code) {
                this.$toast.fail(" 生成二维码失败");
                return;
            }
            this.Loading.clear();
            this.code = code;
        },

        onLoadForCover() {
            this.cover = true;
            this.$nextTick(this.generatePoster);
        },

        async generatePoster() {
            if (!this.code) return;
            const posterCanvas = await html2canvas(
                document.getElementById("codeDom"),
                { backgroundColor: null, scale: 2 }
            );
            this.codePoster = posterCanvas.toDataURL("image/png");
            this.Loading.clear();
        },

        download() {
            uni.postMessage({
                data: { type: "DOWNLOAD", base64: this.codePoster },
            });
        },

        share() {
            uni.postMessage({
                data: { type: "SHARE", base64: this.codePoster },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@font-face {
    font-family: myFirstFont;
    src: url("https://file.kinfriend.com//app/font/%E6%96%B9%E6%AD%A3%E9%AD%8F%E7%A2%91%E7%AE%80%E4%BD%93.ttf");
}
.container {
    min-height: 100vh;
    background-color: #f8f8f8;

    .content {
        margin-top: 8vh;
        margin-left: 5vw;
        width: 90vw;
        height: 80vh;
        position: relative;
        font-family: myFirstFont;
        .title {
            position: absolute;
            right: 13%;
            top: 15%;
            margin: 0 auto;
            font-size: 54px;
            width: 40px;
            height: 50vh;
            writing-mode: vertical-rl;
            text-align: center;
        }
        .branch {
            position: absolute;
            right: 27%;
            top: 28%;
            margin: 0 auto;
            font-size: 48px;
            width: 40px;
            height: 38vh;
            writing-mode: vertical-lr;
            text-align: center;
        }
        .code-content {
            position: absolute;
            right: 28.5%;
            bottom: 8%;
            margin: 0 auto;
            font-size: 48px;
            width: 40px;
            .code-qrcode {
                width: 160px;
                height: 160px;
            }
        }
    }

    .handle {
        display: flex;
        padding-top: 20px;
        padding-bottom: 20px;

        .handle-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 50%;
            flex-shrink: 0;

            .handle-label {
                padding-top: 20px;
                color: #000000;
            }
        }
    }
}
</style>>

